import { lazy } from 'react';
import { ROLE_PERMISSIONS } from './constants';

const RolesPage = lazy(() => import('./pages/RolesPage'));
const RoleDetailPage = lazy(() => import('./pages/RoleDetailPage'));

export const roleRoutes = [
  {
    path: '/roles',
    element: RolesPage,
    permission: ROLE_PERMISSIONS.READ,
    nav: { labelKey: 'nav.roles', icon: 'TeamOutlined', group: 'users' },
  },
  {
    path: '/roles/:portal/:code',
    element: RoleDetailPage,
    permission: ROLE_PERMISSIONS.READ,
  },
];
